import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

import { TtcNzTableModule } from '@libs/src/ttc-nz-table/ttc-nz-table.module';
import { DownloadCsvTemplateModule } from '@main-client/src/app/download-csv-template/download-csv-template.module';
import { MakeSortStringFnPipeModule } from '@main-client/src/app/pipes/make-sort-string-fn/make-sort-string-fn-pipe.module';
import { UploadModule } from '@main-client/src/app/upload/upload.module';

import { RemoveMembersFromHubDialogComponent } from './remove-members-from-hub-dialog.component';

@NgModule({
  declarations: [RemoveMembersFromHubDialogComponent],
  imports: [
    CommonModule,
    DownloadCsvTemplateModule,
    FlexLayoutModule,
    MatButtonModule,
    MakeSortStringFnPipeModule,
    MatDialogModule,
    NzIconModule,
    NzSpinModule,
    NzTabsModule,
    TtcNzTableModule,
    UploadModule,
  ],
  exports: [RemoveMembersFromHubDialogComponent],
})
export class RemoveMembersFromHubDialogModule {}
